var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[(_vm.explorerId)?_c('Explorer',{attrs:{"id":_vm.explorerId,"sso":"true"}}):_c('v-skeleton-loader',{attrs:{"type":"list-item-three-line"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }